module.exports = __webpack_public_path__ + "img/Kenya.bf869678.png";